export const entrega_rules = {
    data() {
        return {
            valid: true,
            required_rules: [
                v => !!v || 'Requerido',
            ],
        }
    },
}